import { ISimpleTableField, simpleTableSortFn } from "@asup/simple-table";
import { tocSort } from "contexts/toc/tocSort";
import { TlfItemTableLinkCell } from "../TlfItemTableLinkCell";

export const TocHeaders: ISimpleTableField[] = [
  {
    name: "tocNumber",
    label: "Number",
    width: "110px",
    // Sort TOC items by number using custom sort function.
    sortFn: (a, b) => tocSort(a.tocNumber as string, b.tocNumber as string),
    // Search TOC items by number or label.
    searchFn: (row, searchText) =>
      ((row.tocNumber as string | undefined)
        ?.toLowerCase()
        .includes(searchText.toLowerCase().trim()) ||
        (row.tocLabel as string | undefined)
          ?.toLowerCase()
          .includes(searchText.toLowerCase().trim())) ??
      false,
    canColumnFilter: true,
    renderFn: TlfItemTableLinkCell,
  },
  {
    name: "tocLabel",
    label: "Title",
    width: "600px",
    sortFn: simpleTableSortFn,
    canColumnFilter: true,
  },
];
